export default {};


//////////////////
// WEBPACK FOOTER
// ./.nuxt/middleware.js
// module id = ./.nuxt/middleware.js
// module chunks = 20